import { CreateSubscriptionRealmForm } from 'RealmModule/components/SubscriptionRealm/CreateSubscriptionRealmForm';
import { StyledSimpleCard } from 'styles';

export const CreateSubscriptionRealmCard = () => {
  return (
    <StyledSimpleCard>
      <CreateSubscriptionRealmForm showAdvancedFields />
    </StyledSimpleCard>
  );
};
